// @flow
import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import clsx from 'clsx';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import ConditionalActionWrapper from 'UI/components/atoms/ConditionalWrapper';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';

import { DrawerContentContainer, DrawerFooter, DrawerHeader, useStyles } from './FPDrawer.styled';

const FPDrawer = ({
  CardHeaderProps,
  ContentWrapper,
  ContentWrapperProps,
  FPDrawerProps,
  additionalHeaderButton = null,
  children,
  contentContainerClassName,
  footer = null,
  hasPaddingContent = true,
  header,
  hideFooter = false,
  onClose
}) => {
  const classes = useStyles({ hasPaddingContent });

  const defaultFooterButtonsDefinitions = [
    { props: { text: strings.shared.ui.close, variant: 'outlined', onClick: onClose } }
  ];

  return (
    <Drawer onClose={onClose} {...FPDrawerProps}>
      {header || (
        <DrawerHeader
          titleTypographyProps={{ component: 'h5' }}
          action={
            <>
              {additionalHeaderButton}
              <FPIconButton
                data-testid={strings.shared.ui.close}
                icon={HighlightOffIcon}
                onClick={onClose}
                tooltipProps={{ title: strings.shared.ui.close }}
              />
            </>
          }
          {...CardHeaderProps}
        />
      )}
      <ConditionalActionWrapper
        condition={!!ContentWrapper}
        wrapper={(c = children) => (
          <ContentWrapper className={classes.contentWrapperStyles} {...ContentWrapperProps}>
            {c}
          </ContentWrapper>
        )}
      >
        <DrawerContentContainer
          classes={{
            root: clsx(classes.root, contentContainerClassName)
          }}
        >
          {children}
        </DrawerContentContainer>

        <When condition={!hideFooter}>
          <DrawerFooter>
            {footer || <FPButtonBuilder buttonDefinitions={defaultFooterButtonsDefinitions} />}
          </DrawerFooter>
        </When>
      </ConditionalActionWrapper>
    </Drawer>
  );
};

export default FPDrawer;
